<template>
  <nav
    :class="{sidebar: true,  active: sidebar.expanded,
      'sidebar-overlay': sidebar.expanded,
      'sidebar-mobile': sidebar.mobile,
      'd-none': !sidebar.expanded}"
  >
    <header class="logo">
      <router-link title="My Account" :to="{name: 'AccountsPage'}"
      >

        <div id="face">
          <div class="left eye">
            <div class="pupil"></div>
          </div>
          <div class="right eye">
            <div class="pupil"></div>
          </div>

          <div style="position:relative;left:40px;top:4px">
           <span style="color:#FFA328">PageWatch</span>
          </div>
        </div>

      </router-link>
    </header>

    <a title="Close" @click="sidebar.expanded = !sidebar.expanded"  v-if="sidebar.expanded && sidebar.mobile" class="sidebar-mobile-close"><span class="fa fa-close"></span></a>
    <template v-if="$route.meta.customMenu === 'account'">
      <ul class="nav" >

        <NavLink
                header="Account Settings"
                :link="`/${$route.params.token}/account/account`"
                iconName="fi flaticon-home"
                index="dashboard"
                isHeader
        />
        <NavLink
                :activeItem="activeTwo"
                header="My Sites"
                :link="`/${$route.params.token}/new`"
                iconName="fa fa-film"
                index="explore"
                :childrenLinks="[
            { header: 'New Site',  badgeColor:'light', link: $router.resolve({ name: 'NewPage', params: {token: $route.params.token} }).href, labelColor: 'danger' },
            { header: 'Manage Sites', link: $router.resolve({ name: 'WebsitesPage', params: {token: $route.params.token} }).href,  badgeColor:'light', labelColor: 'danger' },
          ]"
        />
      </ul>
    </template>
    <template v-else>
    <ul class="nav">

      <NavLink
        header="Overview"
        :link="`/${$route.params.token}/dashboard`"
        iconName="fi flaticon-home"
        index="dashboard"
        isHeader
      />
      <NavLink
              :activeItem="activeTwo"
              header="Explore"
              :link="`/${$route.params.token}/explore`"
              iconName="fa fa-film"
              index="explore"
              :childrenLinks="[
          { header: 'Pages',  badge: `${stats.pageCount}`, badgeColor:'light', link: $router.resolve({ name: 'ExplorePage', params: {token: $route.params.token} }).href, labelColor: 'danger' },
          { header: 'Updates', badge: (!scanStatus.completed || stats.pageCount === 1) ? '' : `${stats.pageCount}`, link: $router.resolve({ name: 'ChangesPage', params: {token: $route.params.token, changeType: 'visual'} }).href,  badgeColor:'light', labelColor: 'danger' },
        ]"
      />
      <NavLink
              :activeItem="activeItem"
              header="Performance"
              :link="`/${$route.params.token}/performance`"
              iconName="fa fa-bar-chart-o"
              index="performance"
              :badge="`${stats.internalRedirectsCount}`"
              badgeColor="warning"
              :childrenLinks="[
          { header: 'Performance', badge: `${stats.performanceReportsCount}`, badgeColor:'light', link: $router.resolve({ name: 'PerformancePerformancePage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
          { header: 'Lighthouse', badge: `${stats.performanceReportsCount}`, badgeColor:'light', link: $router.resolve({ name: 'PerformanceLighthousePage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
          { header: 'Slow Requests', badge: `${stats.performanceReportsCount}`, badgeColor:'light', link: $router.resolve({ name: 'PerformanceNetworkSlowPage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
          { header: 'Large Requests', badge: `${stats.performanceReportsCount}`, badgeColor:'light', link: $router.resolve({ name: 'PerformanceNetworkSizePage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
        ]"
      />
      <NavLink
              :activeItem="activeItem"
              header="Layout Issues"
              :link="`/${$route.params.token}/layout`"
              iconName="glyphicon glyphicon-indent-right"
              index="layout"
              :badge="`${layoutIssuesCount}`"
              :childrenLinks="deviceLayoutSubmenu"
      />
      <NavLink
              :activeItem="activeItem"
              header="Resources"
              :link="`/${$route.params.token}/resources`"
              iconName="fi flaticon-network"
              index="resources"
              :badge="`${stats.brokenLinksCount+stats.brokenImagesCount+stats.brokenResourcesCount}`"
              badgeColor="warning"
              :childrenLinks="[
          { header: 'Broken Links', badge: `${stats.brokenLinksCount}`, badgeColor:'warning', link: $router.resolve({ name: 'BrokenLinksPage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
          { header: 'Broken Images', badge: `${stats.brokenImagesCount}`, badgeColor:'warning', link: $router.resolve({ name: 'BrokenImagesPage', params: {token: $route.params.token} }).href, iconName: 'flaticon-equal-1' },
          { header: 'Broken Resources', badge: `${stats.brokenResourcesCount}`, badgeColor:'warning', link:  $router.resolve({ name: 'BrokenResourcesPage', params: {token: $route.params.token} }).href, iconName: 'flaticon-equal-1' },
        ]"
      />

      <NavLink
              :activeItem="activeItem"
              header="SEO"
              :link="`/${$route.params.token}/seo`"
              iconName="fa fa-rocket"
              index="seo"
              :badge="`${stats.internalRedirectsCount}`"
              badgeColor="warning"
              :childrenLinks="[
          { header: 'Internal Redirects', badge: `${stats.internalRedirectsCount}`, badgeColor:'warning', link: $router.resolve({ name: 'SeoRedirectsPage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
          { header: 'Link Structure', badge: (!scanStatus.completed || stats.pageCount === 1) ? '' : `${stats.pageCount}`, link: $router.resolve({ name: 'SeoSitemapPage', params: {token: $route.params.token} }).href,  badgeColor:'light', labelColor: 'danger' },
        ]"
      />
      <NavLink
              :activeItem="activeItem"
              header="Javascript"
              :link="`/${$route.params.token}/javascript`"
              iconName="fa fa-warning"
              index="javascript"
              :badge="`${stats.consoleLogsCount + stats.vulnerabilitiesCount}`"
              badgeColor="light"
              :childrenLinks="[
          { header: 'Vulnerabilities', badge: `${stats.vulnerabilitiesCount}`, badgeColor:'warning', link: $router.resolve({ name: 'VulnerabilitiesPage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
          { header: 'Console Logs', badge: `${stats.consoleLogsCount}`, badgeColor:'light', link: $router.resolve({ name: 'JavascriptPage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
        ]"
      />
      <NavLink
              :activeItem="activeItem"
              header="Spelling"
              :link="`/${$route.params.token}/spelling`"
              iconName="fa fa-language"
              index="spelling"
              :badge="`${stats.spellingIssuesCount}`"
              badgeColor="warning"
              :childrenLinks="[
          { header: 'Spelling Issues', badge: `${stats.spellingIssuesCount}`, badgeColor:'warning', link: $router.resolve({ name: 'SpellingPage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
          { header: 'Approved Words', link: $router.resolve({ name: 'DictionaryPage', params: {token: $route.params.token} }).href, label: 'ab', labelColor: 'danger' },
        ]"
      />
    </ul>
    <p>

    <h5 class="navTitle">
      STATUS
    </h5>
    <div class="sidebarAlerts">
      <div style="margin:12px">
        <b-spinner v-if="!scanStatus.completed" label="Loading..." style="margin-bottom:3px;margin-right:6px;height:12px;width:12px;color:gray;font-size:8px"></b-spinner> <span v-else :class="`circle bg-${siteStatusInfo.variant} text-warning mr-xs`" style="font-size: 4px;bottom:4px;position:relative; text-transform: capitalize;">.</span><small>{{siteStatusInfo.message}}</small><br />
        <div v-if="scanErrors.length > 0">
          <small style="color:red" id="popover-button-open"><i class="fa fa-warning"></i> {{scanErrors.length}} Errors</small>
          <b-popover target="popover-button-open" :title="`${scanErrors.length} Pages failed to load`" triggers="hover" placement="top">
            <p v-for="entry in scanErrors"><a :href="entry.url" target="_blank">{{entry.url}}</a></p>
          </b-popover>
        </div>
      </div>
    </div>

    <ul class="adminnav" v-if="user.role === 'user'">
      <NavLink
              :activeItem="activeItem"
              header="Admin"
              :link="`/${$route.params.token}/admin`"
              iconName="fa fa-gear"
              index="admin/admin"
              :childrenLinks="[
          { header: 'Api Keys',  badge: ``, badgeColor:'light', link: $router.resolve({ name: 'AdminApiPage', params: {token: $route.params.token} }).href, labelColor: 'danger' },
          { header: 'Integrations',  badge: ``, badgeColor:'light', link: $router.resolve({ name: 'AdminIntegrationsPage', params: {token: $route.params.token} }).href, labelColor: 'danger' },
        ]"
      />
  </ul>
  </template>
    <div v-if="$route.meta.customMenu === 'account'" style="height:200px"></div>
    <p>
      <small class="ml-3 text-muted">© 2021 <a href="https://pagewatch.dev">PageWatch.dev</a></small>
    </p>
  </nav>
</template>

<script>

import _ from 'lodash'
import { mapState, mapActions } from 'vuex';
import NavLink from './NavLink/NavLink';
import gql from "graphql-tag";
export default {
  name: 'Sidebar',
  components: { NavLink },
  apollo: {
    $subscribe: {
      websites_website: {
        query() {
          return gql`subscription {
            websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
              id
              url
              latest_stats
              websites_links_aggregate(where: {active: {_eq: true}}){
                aggregate{
                  count
                }
              }
              websites_crawledpages_aggregate(where: {ready: {_eq: true}, is_latest: {_eq: true}, status: {_lt: 300, _gte: 200}}){
                aggregate {
                  count
                }
              }
                broken_links:websites_links_aggregate(where: {active: {_eq: true}, is_broken: {_eq: true}}){
                  aggregate{
                    count
                  }
                }
                internal_redirects:websites_links_aggregate(where: {active: {_eq: true}, is_broken: {_eq: false}, internal_redirect: {_eq: true}}){
                  aggregate{
                    count
                  }
                }
                websites_consolelogs_aggregate(where: {active: {_eq: true}}){
                  aggregate{
                    count
                  }
                }
                websites_vulnerabilities_aggregate(where: {active: {_eq: true}}){
                  aggregate{
                    count
                  }
                }
                websites_spellingerrors_aggregate(where: {active: {_eq: true}}) {
                  aggregate {
                    count
                  }
                }
                broken_images:websites_brokenresources_aggregate(where: {active: {_eq: true}, resource_type: {_in: ["image"]}}){
                  aggregate{
                    count
                  }
                }
                broken_resources:websites_brokenresources_aggregate(where: {active: {_eq: true}, resource_type: {_in: ["js", "other"]}}){
                  aggregate{
                    count
                  }
                }

            }
          }`
        },
        skip () {
          return !this.activeSite.id || (this.dataLoaded && this.scanStatus.completed);
        },
        result (data) {
          this.pageCount = 0;
          this.numberOfPages = 1;
          let website = data.data.websites_website[0];

          this.layoutIssuesCount = (website.latest_stats['layout_issues'] && website.latest_stats['layout_issues']['total'] )|| 0;
          this.deviceLayoutSubmenu = this.activeSite.devices.map( (v) => {
            let issuesCount = (website.latest_stats['layout_issues'] && website.latest_stats['layout_issues']['pages'][v.id]) || 0;
            return {
              header: v.platform,
              link: `/${this.$route.params.token}/layout/issues/${v.id}`,
              smallText: `${v.width}x${v.height}`,
              badge: `${issuesCount}`,
              badgeColor: 'warning',
              width: v.width,
            }
          });
          this.deviceLayoutSubmenu.sort( (a,b) => { return a.width - b.width});

          this.stats = {
            performanceReportsCount: (website.latest_stats['performance'] && website.latest_stats['performance']['reports'] )|| 0,
            pageCount: website.websites_crawledpages_aggregate.aggregate.count,
            linksCount: website.websites_links_aggregate.aggregate.count,
            brokenLinksCount: website.broken_links.aggregate.count,
            internalRedirectsCount: website.internal_redirects.aggregate.count,
            consoleLogsCount: website.websites_consolelogs_aggregate.aggregate.count,
            vulnerabilitiesCount: website.websites_vulnerabilities_aggregate.aggregate.count,
            spellingIssuesCount: website.websites_spellingerrors_aggregate.aggregate.count,
            brokenImagesCount: website.broken_images.aggregate.count,
            brokenResourcesCount: website.broken_resources.aggregate.count,
          };

          this.dataLoaded = true;
        },

      },

    }
  },
  data() {
    return {
      selected: null,
      dataLoaded: false,
      stats: {},
      activeTwo: "admin/explore",
      layoutIssuesCount: 0,
      deviceLayoutSubmenu: [],
      value: null,
    };
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive']),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/');
      paths.pop();
      this.changeSidebarActive(paths.join('/'));
      this.sidebar.expanded = window.innerWidth >= 768;
    },
    onWindowResize: _.debounce(function () {
      this.sidebar.mobile = window.innerWidth < 768;
      this.sidebar.expanded = window.innerWidth >= 768;
    }, 100)
  },
  props: {
    sidebar: {
      expanded: Boolean
    }
  },
  created() {
    this.$watch("$route",() => {
      this.setActiveByRoute();
    }, {
      immediate: true
    });
    this.$root.$on('global_reload', () => {
      this.dataLoaded = false;
    });



  },
  mounted () {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();

    var pupils = document.querySelectorAll(".pupil");
    var mouseX = 0;
    var mouseY = 0;

    for (var i = 0; i < pupils.length; i++) {
      var offset = pupils[i].getBoundingClientRect();
      pupils[i]['centerX'] = offset.left + offset.width/2,
              pupils[i]['centerY'] = offset.bottom;
    }

    function goGoogly(e) {
      var pointerEvent = e;

      mouseX = e.clientX + window.pageXOffset,
              mouseY = e.clientY + window.pageYOffset;

      for (var i = 0; i < pupils.length; i++) {
        pupils[i]['radians'] = Math.atan2(mouseX - pupils[i]['centerX'], mouseY - pupils[i]['centerY']),
                pupils[i]['degree'] = (pupils[i]['radians'] * (180 / Math.PI) * -1);
        pupils[i].style.transform = 'rotate('+ (pupils[i]['degree'] + 180) + 'deg)';
      }
    }

    window.addEventListener('mousemove', goGoogly);
    window.addEventListener('touchstart', goGoogly);
    window.addEventListener('touchmove', goGoogly);

  },
  watch: {
    'activeSite': function () {
      this.dataLoaded = false;
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.onWindowResize)
  },
  computed: {
    ...mapState('layout', {
      activeItem: state => state.sidebarActiveElement,
    }),
    ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus", user: 'user'}),
    siteStatusInfo(){
      if (this.scanStatus.completed){
        return {
          variant: 'success',
          message: 'Completed',
        }
      }
      else if (!this.scanStatus.site.completed){
        if (this.scanStatus.site.status === 'error'){
          return {
            variant: 'danger',
            message: 'Error',
          }
        }
        else {
          return {
            variant: 'warning',
            message: this.scanStatus.statusText,
          }
        }
      }
      else{
        return {
          variant: 'warning',
          message: 'Checking Page',
        }
      }
    },
    scanErrors(){
      let errors = [];
      for (let entry of this.scanStatus.site.errors){
        errors.push({
          'path': entry.url,
          'url': entry.url,
        })
      }

      for (let entry of this.scanStatus.pageErrors){
          errors.push({
            'path': entry,
            'url': entry,
          })
      }
      return errors;

    }
  },
};
</script>
<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped/>

